import { render, staticRenderFns } from "./PelleRift.vue?vue&type=template&id=aa9407ec&scoped=true&"
import script from "./PelleRift.vue?vue&type=script&lang=js&"
export * from "./PelleRift.vue?vue&type=script&lang=js&"
import style0 from "./PelleRift.vue?vue&type=style&index=0&id=aa9407ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9407ec",
  null
  
)

export default component.exports